export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
  }
}

export class Distribution {
  count_info: any
  rate_info: any
  devision_info: any
  total_ratings: number[]

  constructor(distribution: any){
    this.count_info = distribution.count_info;
    this.rate_info = distribution.rate_info;
    this.devision_info = distribution.devision_info;
    this.total_ratings = distribution.total_ratings;
  }
}

export class Room {
  id: number
  name: string

  constructor(room: any){
    this.id = room.room_id;
    this.name = room.room_name;
  }
}

export class Curriculum {
  id: number
  name: string

  constructor(curriculum: any){
    this.id = curriculum.id;
    this.name = curriculum.name;
  }
}